import React from 'react';
import { FieldSchema } from '../../types';
import { FieldWrapper } from './FieldWrapper';
import { StringInput } from '../atoms/inputs/StringInput';
import { NumberInput } from '../atoms/inputs/NumberInput';
import { BooleanInput } from '../atoms/inputs/BooleanInput';
import { DateInput } from '../atoms/inputs/DateInput';

interface SchemaFieldProps {
  field: FieldSchema;
  value: any;
  onChange: (value: any) => void;
  error?: string;
  isOverridden?: boolean;
  onToggleOverride: () => void;
  readOnly?: boolean;
}

export const SchemaField: React.FC<SchemaFieldProps> = ({
  field,
  value,
  onChange,
  error,
  isOverridden,
  onToggleOverride,
  readOnly
}) => {
  const commonProps = {
    value,
    onChange,
    readOnly,
    placeholder: field.placeholder,
    hasError: !!error,
    isOverridden
  };

  const renderInput = () => {
    switch (field.type) {
      case 'number':
        return <NumberInput {...commonProps} />;
      case 'boolean':
        return <BooleanInput {...commonProps} />;
      case 'date':
        return <DateInput {...commonProps} />;
      case 'email':
        return <StringInput {...commonProps} type="email" />;
      case 'string':
      default:
        return <StringInput {...commonProps} />;
    }
  };

  return (
    <FieldWrapper
      label={field.label}
      error={error}
      isOverridden={isOverridden}
      onToggleOverride={onToggleOverride}
      readOnly={readOnly}
      hint={field.hint}
      showIcon={field.type !== 'boolean'}
    >
      {renderInput()}
    </FieldWrapper>
  );
};
